<template>
  <app-modal>
    <el-card class="box-card">
      <h2>Arrastra los items arriba / abajo para ordenar</h2>
      <hr />
      <draggable v-model="items">
        <transition-group name="list-complete">
          <div class="item" v-for="element in items" :key="element.id" v-if="element.id != 0">
            <i class="el-icon-d-caret"></i>
            <img v-if="table == 'imagen'" :src="element.url" alt height="50px" />
            <span>{{ element[name] }}</span>
            <hr />
          </div>
        </transition-group>
      </draggable>
      <el-button @click="update">Guardar</el-button>
    </el-card>
  </app-modal>
</template>
<script>
import ApiService from "@/common/api.service";
import { API_UPLOADS } from "@/common/config";
import Modal from "@/components/Dashboard/Modals/modal";
import draggable from "vuedraggable";

export default {
  name: "modalDraggable",
  props: ["content", "name", "table"],
  components: {
    "app-modal": Modal,
    draggable
  },
  created() {
    this.items = [
      {
        id: 0,
        order: 0
      }
    ];

    this.content.forEach(element => {
      this.items.push(element);
    });
  },
  data() {
    return {
      btn: "Guardar",
      items: null,
      show: false,
      folder: API_UPLOADS
    };
  },
  methods: {
    closeModal() {
      this.$root.$emit("closeModal");
    },
    update() {
      if (this.table === "contents") {
        this.items.forEach((element, index) => {
          if (element.id != 0) {
            let form = { order_row: index };
            ApiService.post("dashboard/editform", {
              table: this.table,
              token: localStorage.getItem("token"),
              project_id: localStorage.getItem("table"),
              form: form,
              id: element.content_id
            }).then(response => {
              this.$notify({
                title: "Actualizado",
                message: element.title + "actualizado",
                type: "success"
              });
            });
          }
        });
      } else if (this.table === "documental_documentos") {
        this.items.forEach((element, index) => {
          if (element.id != 0) {
            let form = { order_row: index };
            ApiService.post("dashboard/editform", {
              table: this.table,
              token: localStorage.getItem("token"),
              project_id: localStorage.getItem("table"),
              form: form,
              id: element.id_documental_documentos
            }).then(response => {
              this.$notify({
                title: "Actualizado",
                message: element.title + "actualizado",
                type: "success"
              });
            });
          }
        });
      } else if (this.table === "listados_entradas") {
        this.items.forEach((element, index) => {
          if (element.id != 0) {
            let form = { order_row: index };
            ApiService.post("dashboard/editform", {
              table: this.table,
              token: localStorage.getItem("token"),
              project_id: localStorage.getItem("table"),
              form: form,
              id: element.id_listados_entradas
            }).then(response => {
              this.$notify({
                title: "Actualizado",
                message: element.title + "actualizado",
                type: "success"
              });
            });
          }
        });
      } else {
        this.items.forEach((element, index) => {
          if (element.id != 0) {
            let form = { order_row: index };
            ApiService.post("dashboard/editform", {
              table: this.table,
              token: localStorage.getItem("token"),
              project_id: localStorage.getItem("table"),
              form: form,
              id: element.id
            }).then(response => {
              this.$notify({
                title: "Actualizado",
                message: element.title + "actualizado",
                type: "success"
              });
            });
          }
        });
      }

      setTimeout(() => {
        this.closeModal();
      }, 100);
    }
  }
};
</script>

<style scoped>
.item {
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Modals/draggable.vue